import React from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const filled = (TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100;
  return <div className="mx-auto w-full max-w-xl" data-id="element-273" data-mp="2l5pq09ffuee5">
      <div className="flex items-center justify-between gap-3 text-sm font-bold" data-id="element-274" data-mp="2l2tqwhrutjo4">
        <span className="flex items-center gap-1.5 text-white" data-id="element-275" data-mp="2q2g5ovnbz7z1">
          <FlameIcon className="h-4 w-4 text-alert" aria-hidden="true" data-id="element-276" data-mp="2b6gyrobyjdvh" />
          Only {SPOTS_LEFT} spots left at the promo price
        </span>
        <span className="shrink-0 text-alert" data-id="element-277" data-mp="2g74om6og9oo4">{Math.round(filled)}% claimed</span>
      </div>
      <div className="mt-2 h-4 w-full overflow-hidden rounded-full bg-line" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-278" data-mp="227wlj2p61wen">
        <div className="h-full rounded-full bg-alert" style={{
        width: `${filled}%`
      }} data-id="element-279" data-mp="5e1vslrt6zz1" />
      </div>
    </div>;
}